module.exports = __webpack_public_path__ + "fil_icon.svg?db474a72881fcbd29464e9da254b34fe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/fil_icon.svg
// module id = 1151
// module chunks = 2